module.exports = __webpack_public_path__ + "img/breakfast_bistro_menu1.de35346b.png";